import {Pipe, PipeTransform} from '@angular/core';
import {IPlaylist} from "@interfaces/playlist";

@Pipe({
    name: 'totalPlaylistDuration'
})
export class TotalPlaylistDurationPipe implements PipeTransform {

    transform(playlist: IPlaylist): number {
        return this.totalMediasDuration(playlist);
    }

    private totalMediasDuration(playlist: IPlaylist): number {
        return playlist.medias
            .filter((media) => media.chanel !== 'audio')
            .map((media) => media.duration)
            .reduce((acc, curr) => {
                return acc + curr;
            }, 0)
    }
}
